import React from "react";
import "./ECLUtility.css";
import { ECLThemeImage } from "../../../eclComponents/";
import { staticURL } from "../../../utilities/requests";

export default function ECLUtility(props) {
   //PROPS
   //backgroundImg - string - for the src of the background
   return (
      <div className="utility-wrapper">
         <div className="content-container">
            <ECLThemeImage
               darkThemeRoute={
                  staticURL + "Logos/S1-Logo-EKPS-Stacked-dark.svg"
               }
               lightThemeRoute={
                  staticURL + "Logos/S1-Logo-EKPS-Stacked-Light.svg"
               }
               alt="SourceOne EKPS"
               style={{
                  height: "150px",
                  display: "flex",
                  justifyContent: "center",
               }}
            />
            <div className="variable-content-wrapper">{props.children}</div>
         </div>
      </div>
   );
}
